import React, { useState, useEffect } from 'react'
import { useMemoizedFn } from 'ahooks'
import { message as $message } from 'antd'
import { querySupplierSkuLimit } from '@/services/distributeOrder'

interface useSupplierSkuCountReturn {
    /** erpsku数量是否超出限制 */
    isExcee: Boolean
    /** 设置coid */
    setSupplierCoId: React.Dispatch<React.SetStateAction<null>>
}

export default (): useSupplierSkuCountReturn => {
    const [supplierCoId, setSupplierCoId] = useState(null)
    const [isExcee, setIsExcee] = useState(false)

    const init = useMemoizedFn(async () => {
        const { success, message, data } = await querySupplierSkuLimit({ supplierCoId })

        if (success) {
            if (data) {
                setIsExcee(true)
            } else {
                setIsExcee(false)
            }
        } else {
            $message.error(message)
        }
    })

    useEffect(() => {
        if (supplierCoId) {
            init()
        }
    }, [init, supplierCoId])

    return { isExcee, setSupplierCoId }
}
